import { useEffect } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import Services from "../trustBuilder/Services/Services";

const ENTRA_FLOW = "ENTRA";

export default function AuthFlowGate({
  authCode,
  authFlow,
  hasSession,
  isCallbackRoute,
  isRedirectProcessing,
  shouldTriggerRedirect,
  onTrustBuilderRedirect,
  onEntraRedirect
}) {
  useEffect(() => {
    if (authCode || hasSession || isCallbackRoute || isRedirectProcessing || !shouldTriggerRedirect) {
      return;
    }

    Services.removeAuthData();

    if (authFlow === ENTRA_FLOW) {
      if (onEntraRedirect) {
        onEntraRedirect();
      }
      return;
    }

    if (onTrustBuilderRedirect) {
      onTrustBuilderRedirect();
    }
  }, [
    authCode,
    authFlow,
    hasSession,
    isCallbackRoute,
    isRedirectProcessing,
    onEntraRedirect,
    onTrustBuilderRedirect,
    shouldTriggerRedirect
  ]);

  if (hasSession) {
    return <Layout />;
  }

  // If no redirect is requested, fall back to app routes instead of rendering a blank screen.
  if (!shouldTriggerRedirect && !isCallbackRoute && !isRedirectProcessing) {
    return <Layout />;
  }

  if (!authCode) {
    return null;
  }

  return <Layout />;
}

AuthFlowGate.propTypes = {
  authCode: PropTypes.string,
  authFlow: PropTypes.string,
  hasSession: PropTypes.bool,
  isCallbackRoute: PropTypes.bool,
  isRedirectProcessing: PropTypes.bool,
  shouldTriggerRedirect: PropTypes.bool,
  onTrustBuilderRedirect: PropTypes.func,
  onEntraRedirect: PropTypes.func,
};
